module.exports = __webpack_public_path__ + "img/GAME_GOSTOP.0d481761.png";